<template>
    <!--   营销管理－活动管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this, 'activeIndex')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="活动名称">
                    <a-input placeholder="请输入" v-decorator="['actName']"></a-input>
                </a-form-item>
                <a-form-item label="商品名称">
                    <a-input placeholder="请输入" v-decorator="['commodityName']"></a-input>
                </a-form-item>
                <a-form-item label="活动时间">
                    <a-range-picker
                        style="width:282px"
                        showTime
                        format="YYYY/MM/DD HH:mm"
                        v-decorator="['selectDate']"
                    />
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>

        <div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <router-link slot="extra" to="/activeIndex/newActive">
                    <a-button type="primary">新增活动商品</a-button>
                </router-link>
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :scroll="{ x: 800 }" 
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                >
                    <span slot="index" slot-scope="a,item,i">{{i+1}}</span>
                    <span slot="startTime" slot-scope="startTime,item">{{startTime +' ~ '+item.endTime}}</span>
                    <span slot="action" slot-scope="a,item">
                        <span v-if="getBtnByAuth('activeEdit')">
                            <a v-if="noTitleKey == 0 || noTitleKey == 2" @click="activeEdit(item.id)" class="text-primary">编辑<a-divider type="vertical" /></a>
                            <a v-else class="text-disabled">编辑<a-divider type="vertical" /></a>
                        </span>
                        <span v-if="getBtnByAuth('activeDetail')">
                            <a @click="activeDetail(item.id)" class="text-primary">详情<a-divider type="vertical" /></a>
                        </span>
                        <span v-if="getBtnByAuth('activeState')">
                            <a-popconfirm
                                v-if="noTitleKey == 0 || noTitleKey == 1"
                                :title='"确认"+(noTitleKey == 0 ? "上线" : "下线")+"吗？"'
                                @confirm="activeState(item.id,noTitleKey)"
                                >
                                <a class="text-primary">{{noTitleKey == 0 ? '上线' : '下线'}}</a>
                            </a-popconfirm>
                            <a v-else class="text-disabled">{{noTitleKey == 0 ? '上线' : '下线'}}</a>
                            <a-divider type="vertical" />
                        </span>
                        <span v-if="getBtnByAuth('activeDelete')">
                            <a-popconfirm
                                v-if="noTitleKey != 1"
                                title="确认删除吗？"
                                @confirm="activeDelete(item.id)"
                                >
                                <a class="text-primary">删除</a>
                            </a-popconfirm>
                            <a v-else class="text-disabled">删除</a>
                        </span>
                    </span>
                </a-table>
            </a-card>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from "moment";
    import { mapGetters } from "vuex";

    const tabListNoTitle = [
        {
            key: '1',
            tab: '进行中',
            columnLine: columns
        },
        {
            key: '0',
            tab: '调整中',
            columnLine: columns
        },
        {
            key: '2',
            tab: '未开始',
            columnLine: columns
        },
        {
            key: '3',
            tab: '已结束',
            columnLine: columns
        }
    ]
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "活动名称",
            dataIndex: "actName"
        },
        {
            title: "活动日期",
            dataIndex: "startTime",
            scopedSlots: { customRender: "startTime" }
        },
        {
            title: "商品名称",
            dataIndex: "commodityName"
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    export default {
        name: "active",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
                tabListNoTitle: tabListNoTitle,
                noTitleKey: '1',
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "activeIndex") {
                    this.getList();
                }
            },
            'shopId'(val) {
                this.getList()
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        methods: {
            // 时间选择
            moment,
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey
                this.pagination.current = 1;
                this.getList()
            },
            //获取列表
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['selectDate'] ? values['selectDate'] : []
                    values.startTime = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.endTime = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD HH:mm:ss') : undefined
                    delete values.selectDate
                    values.state = this.noTitleKey
                    values.shopId = this.shopId

                    this.$api.changeCode
                        .listActivity({
                            body: Object.assign(values, {
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize
                            })
                        })
                        .then(res => {
                            this.dataSource = res.data;
                            this.$set(this.pagination, "total", Number(res.total));
                        });
                });
            },

            activeDetail(id) {
                this.$router.push({
                    path: "/activeIndex/detailActive",
                    query: { id: id }
                });
            },
            activeEdit(id) {
                this.$router.push({
                    path: "/activeIndex/editActive",
                    query: { id: id }
                });
            },
            activeState(id) {
                this.$api.changeCode.stateActivity({
                    body: {
                        id: id,
                        state: this.noTitleKey === '0' ? 1 : 0
                    }
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                })
            },
            activeDelete(id) {
                this.$api.changeCode.deleteActivity({
                    params: {id: id}
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                })
            }
        }
    };
</script>
<style lang="scss">
    .container {
        background: #fff;
    }
</style>